import { defineMessages } from '@formatjs/intl';

import { MentalHealthSectionTitle, MentalHealthSlide } from '../MentalHealthTools/types';

export const messages = defineMessages({
	heading: {
		id: 'b2b.mentalHealthTools.heading',
		defaultMessage: 'Mental health tools for real life.',
		description: 'Heading for section with the various mental health tools that Calm provides',
	},
	copy: {
		id: 'b2b.mentalHealthTools.copy',
		defaultMessage:
			"Calm makes it easy to find what you're looking for and explore it at your own pace. Whether you want to sleep better, feel more relaxed, or improve your focus and productivity, Calm has something for you.",
		description: 'Description of how Calm can help your mental health',
	},
	slide1Title: {
		id: 'b2b.mentalHealthTools.slide1.title',
		defaultMessage: 'Sleep',
		description: 'Title for mental health tools slide',
	},
	slide1Heading: {
		id: 'b2b.mentalHealthTools.slide1.heading',
		defaultMessage: 'Join millions of sound sleepers worldwide.',
		description: 'Heading for mental health tools slide',
	},
	slide1Copy: {
		id: 'b2b.mentalHealthTools.slide1.copy',
		defaultMessage:
			'Our 300+ Sleep Stories, sleep meditations, and calming music will guide you off to sleep quickly and naturally. Just press play and drift away.',
		description: 'Copy for mental health tools slide',
	},
	slide1ContentTitle: {
		id: 'b2b.mentalHealthTools.slide1.contentTitle',
		defaultMessage: 'Dream with Me',
		description: "Title of slide's previewable content",
	},
	slide1ContentSubheading: {
		id: 'b2b.mentalHealthTools.slide1.contentSubheading',
		defaultMessage: 'Fall asleep and fall in love with the dreamy voice of Harry Styles.',
		description: "Information for slide's previewable content",
	},
	slide1ContentAuthor: {
		id: 'b2b.mentalHealthTools.slide1.contentAuthor',
		defaultMessage: 'Narrated by Harry Styles',
		description: "Author of slide's previewable content",
	},
	slide2Title: {
		id: 'b2b.mentalHealthTools.slide2.title',
		defaultMessage: 'Stress & Anxiety',
		description: 'Title for mental health tools slide',
	},
	slide2Heading: {
		id: 'b2b.mentalHealthTools.slide2.heading',
		defaultMessage: 'Get in-the-moment relief from everyday stress and anxiety.',
		description: 'Heading for mental health tools slide',
	},
	slide2Copy: {
		id: 'b2b.mentalHealthTools.slide2.copy',
		defaultMessage:
			'Our clinical experts and mindfulness teachers are here to support you, with a wide range of programs for work stress, acute anxiety, negative thoughts, and more.',
		description: 'Copy for mental health tools slide',
	},
	slide2ContentTitle: {
		id: 'b2b.mentalHealthTools.slide2.contentTitle',
		defaultMessage: 'Overcome Stress and Anxiety',
		description: "Title of slide's previewable content",
	},
	slide2ContentSubheading: {
		id: 'b2b.mentalHealthTools.slide2.contentSubheading',
		defaultMessage: '11 tools to reclaim your calm',
		description: "Information for slide's previewable content",
	},
	slide2ContentAuthor: {
		id: 'b2b.mentalHealthTools.slide2.contentAuthor',
		defaultMessage: 'Narrated by  Dr. Julie Smith',
		description: "Author of slide's previewable content",
	},
	slide3Title: {
		id: 'b2b.mentalHealthTools.slide3.title',
		defaultMessage: 'Focus',
		description: 'Title for mental health tools slide',
	},
	slide3Heading: {
		id: 'b2b.mentalHealthTools.slide3.heading',
		defaultMessage: 'Tame the distraction dragon.',
		description: 'Heading for mental health tools slide',
	},
	slide3Copy: {
		id: 'b2b.mentalHealthTools.slide3.copy',
		defaultMessage:
			'Sharpen your focus with soundscapes and music carefully crafted to help you tune out distractions and tap into a state of flow.',
		description: 'Copy for mental health tools slide',
	},
	slide3ContentTitle: {
		id: 'b2b.mentalHealthTools.slide3.contentTitle',
		defaultMessage: 'Finding Focus',
		description: "Title of slide's previewable content",
	},
	slide3ContentSubheading: {
		id: 'b2b.mentalHealthTools.slide3.contentSubheading',
		defaultMessage: 'Practice simply paying attention',
		description: "Information for slide's previewable content",
	},
	slide3ContentAuthor: {
		id: 'b2b.mentalHealthTools.slide3.contentAuthor',
		defaultMessage: 'Narrated by Jeff Warren',
		description: "Author of slide's previewable content",
	},
	slide4Title: {
		id: 'b2b.mentalHealthTools.slide4.title',
		defaultMessage: 'Relaxation',
		description: 'Title for mental health tools slide',
	},
	slide4Heading: {
		id: 'b2b.mentalHealthTools.slide4.heading',
		defaultMessage: "We don't call it Calm for nothing.",
		description: 'Heading for mental health tools slide',
	},
	slide4Copy: {
		id: 'b2b.mentalHealthTools.slide4.copy',
		defaultMessage:
			'Open the app and enter a sanctuary of rest and relaxation, from soothing soundscapes to calming music to hundreds of titles for deep and peaceful sleep.',
		description: 'Copy for mental health tools slide',
	},
	slide4ContentTitle: {
		id: 'b2b.mentalHealthTools.slide4.contentTitle',
		defaultMessage: 'Rain on Leaves',
		description: "Title of slide's previewable content",
	},
	slide4ContentSubheading: {
		id: 'b2b.mentalHealthTools.slide4.contentSubheading',
		defaultMessage: 'Soothing sounds of rainfall',
		description: "Information for slide's previewable content",
	},
	slide5Title: {
		id: 'b2b.mentalHealthTools.slide5.title',
		defaultMessage: 'Building Habits',
		description: 'Title for mental health tools slide',
	},
	slide5Heading: {
		id: 'b2b.mentalHealthTools.slide5.heading',
		defaultMessage: "You're in the right place.",
		description: 'Heading for mental health tools slide',
	},
	slide5Copy: {
		id: 'b2b.mentalHealthTools.slide5.copy',
		defaultMessage:
			'Our daily programs make it easy to get started and stay on track, and our instructors are here for you every step of the way. Choose from 4 daily programs, each designed to fit into your lifestyle in practical ways.',
		description: 'Copy for mental health tools slide',
	},
	slide5ContentTitle: {
		id: 'b2b.mentalHealthTools.slide5.contentTitle',
		defaultMessage: 'Own the Day',
		description: "Title of slide's previewable content",
	},
	slide5ContentSubheading: {
		id: 'b2b.mentalHealthTools.slide5.contentSubheading',
		defaultMessage: 'Tiny choices and small actions that can lead to lifelong change',
		description: "Information for slide's previewable content",
	},
	slide5ContentAuthor: {
		id: 'b2b.mentalHealthTools.slide5.contentAuthor',
		defaultMessage: 'Narrated by Jay Shetty',
		description: "Author of slide's previewable content",
	},
	slide6Title: {
		id: 'b2b.mentalHealthTools.slide6.title',
		defaultMessage: 'Physical Wellbeing',
		description: 'Title for mental health tools slide',
	},
	slide6Heading: {
		id: 'b2b.mentalHealthTools.slide6.heading',
		defaultMessage: 'A healthier relationship with your body is possible.',
		description: 'Heading for mental health tools slide',
	},
	slide6Copy: {
		id: 'b2b.mentalHealthTools.slide6.copy',
		defaultMessage:
			'Start with the Daily Move, a fresh mindful movement video released each day, as well as guided audio sessions for walking and pain.',
		description: 'Copy for mental health tools slide',
	},
	slide6ContentTitle: {
		id: 'b2b.mentalHealthTools.slide6.contentTitle',
		defaultMessage: 'Mindful Walking',
		description: "Title of slide's previewable content",
	},
	slide6ContentSubheading: {
		id: 'b2b.mentalHealthTools.slide6.contentSubheading',
		defaultMessage: 'A guided meditation for walking mindfully',
		description: "Information for slide's previewable content",
	},
	slide6ContentAuthor: {
		id: 'b2b.mentalHealthTools.slide6.contentAuthor',
		defaultMessage: 'Narrated by Tamara Levitt',
		description: "Author of slide's previewable content",
	},
});

export const sections: Record<MentalHealthSectionTitle, MentalHealthSlide> = {
	sleep: {
		title: messages.slide1Title,
		heading: messages.slide1Heading,
		copy: messages.slide1Copy,
		contentTitle: messages.slide1ContentTitle,
		contentSubheading: messages.slide1ContentSubheading,
		contentUrl: '/app/player/2QQEAZ7IsG',
		author: messages.slide1ContentAuthor,
		imageUrl: '/_n/images/homepage/player-harry.webp',
		audioSrc: '/_n/audio/subpages/SLEP_0184_DreamWithMe_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	stress: {
		title: messages.slide2Title,
		heading: messages.slide2Heading,
		copy: messages.slide2Copy,
		contentTitle: messages.slide2ContentTitle,
		contentSubheading: messages.slide2ContentSubheading,
		contentUrl: '/app/player/QgbYQrASjO',
		author: messages.slide2ContentAuthor,
		imageUrl: '/_n/images/homepage/player-stress.webp',
		audioSrc: 'https://assets.calm.com/7bacc0fc9d6530b171bd6ed7bab4f3e7.m4a',
	},
	focus: {
		title: messages.slide3Title,
		heading: messages.slide3Heading,
		copy: messages.slide3Copy,
		contentTitle: messages.slide3ContentTitle,
		contentSubheading: messages.slide3ContentSubheading,
		contentUrl: '/app/player/uvqyM--Byq',
		author: messages.slide3ContentAuthor,
		imageUrl: '/_n/images/homepage/player-focus.webp',
		audioSrc: 'https://assets.calm.com/7466488786a895624e6d8286b4e3138f.m4a',
	},
	relaxation: {
		title: messages.slide4Title,
		heading: messages.slide4Heading,
		copy: messages.slide4Copy,
		contentTitle: messages.slide4ContentTitle,
		contentSubheading: messages.slide4ContentSubheading,
		imageUrl: '/_n/images/homepage/player-relaxation.webp',
		audioSrc: '/_n/audio/subpages/SSPS_0020_RainOnLeaves_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	habits: {
		title: messages.slide5Title,
		heading: messages.slide5Heading,
		copy: messages.slide5Copy,
		contentTitle: messages.slide5ContentTitle,
		contentSubheading: messages.slide5ContentSubheading,
		contentUrl: '/app/player/_6cjk5C7D-',
		author: messages.slide5ContentAuthor,
		imageUrl: '/_n/images/homepage/player-habits.webp',
		audioSrc: '/_n/audio/subpages/DJAY_OwnTheDay_EN_2CH_MK_20230802_HomepageCutdown.mp3',
	},
	wellbeing: {
		title: messages.slide6Title,
		heading: messages.slide6Heading,
		copy: messages.slide6Copy,
		contentTitle: messages.slide6ContentTitle,
		contentSubheading: messages.slide6ContentSubheading,
		contentUrl: '/app/player/JLpKB3xLL',
		author: messages.slide6ContentAuthor,
		imageUrl: '/_n/images/homepage/player-physical.webp',
		audioSrc: 'https://assets.calm.com/ebabec395bc04c115456cb11cc26ecab.m4a',
	},
};
